import { TENANT_ID } from 'common/constants';

export const getUserTenantId = () => {
  const tenantId = localStorage.getItem('tenantId');

  return tenantId || TENANT_ID.LEAGUE;
};
